import React, { useContext, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { LiliButton } from '@lili/lili-frontend-common';
import Heading from '../../../generic-components/Heading';
import { STYLES, TEXT, LiliPlanType } from '../constants';
import Lottie from '../../../generic-components/Lottie';
import CheckSignLottie from '../../../assets/lotties/checkmark_success_animation.json';
import { ILiliPlan } from '../types';
import { trackMixPanel } from '../../../services/mixpanel.service';
import { FlowContext } from '../index';
import { planReportName } from '../service';
import { useUploadGenericFile } from '../../../hooks/utilities/useUploadGenericFile';
import { GENERIC_FILE_UPLOAD_TYPES } from '../../../types';

interface IProps {
  newPlan: ILiliPlan;
  currentPlanType: string;
  onGreatClick: () => void;
}
export const PlanPickerSuccess = ({ newPlan, currentPlanType, onGreatClick }: IProps) => {
  const { t } = useTranslation();
  const subtitle = useMemo(
    () =>
      t(TEXT.PLAN_PICKER.SUCCESS_SUBTITLE).replace('[PLAN NAME]', newPlan.name).replace('[PLAN NAME]', newPlan.name),
    [newPlan],
  );
  const flowContext = useContext(FlowContext);
  const { mutateAsync: postUploadSnapShot } = useUploadGenericFile();
  const { mutateReportState, reportsState } = flowContext;
  const onGreatClickHandler = () => {
    trackMixPanel('Act on Lili Plans Upgrade Confirmation Screen', {
      Action: 'Great',
    });
    onGreatClick();
  };

  useEffect(() => {
    (async () => {
      await postUploadSnapShot({
        fileUsageType: GENERIC_FILE_UPLOAD_TYPES.PLAN_UPGRADE_SUCCESS,
        imageName: `${Date.now()}`,
      });
    })();
    if (!reportsState.didReportSuccessView) {
      trackMixPanel('View Lili Plans Upgrade Confirmation Screen', {
        'New Plan': planReportName(newPlan?.type),
        'Current Plan': planReportName(currentPlanType),
      });
      if (mutateReportState) {
        mutateReportState({
          ...reportsState,
          didReportSuccessView: true,
        });
      }
    }
  }, []);
  return (
    <div className={STYLES.INDEX.PLAN_PICKER.SUCCESS.LAYOUT}>
      <Lottie className='w-[76px] h-[76px] ' isAutoplay isLoop={false} lottieAsset={CheckSignLottie} />

      <div className='flex flex-col items-center'>
        <Heading
          id='upgradeSuccessInfo'
          title={t(TEXT.PLAN_PICKER.SUCCESS_TITLE)}
          className={STYLES.INDEX.PLAN_PICKER.SUCCESS.TITLE}
        />
        <Heading
          title={newPlan.type === LiliPlanType.PREMIUM ? t(TEXT.PLAN_PICKER.PREMIUM_SUCCESS_SUBTITLE) : subtitle}
          className={STYLES.INDEX.PLAN_PICKER.SUCCESS.SUBTITLE}
        />
      </div>
      <Heading
        title={t(
          newPlan.type === LiliPlanType.PREMIUM
            ? TEXT.PLAN_PICKER.PREMIUM_SUCCESS_DISCLAIMER
            : TEXT.PLAN_PICKER.SUCCESS_DISCLAIMER,
        )}
        className={STYLES.INDEX.PLAN_PICKER.SUCCESS.DISCLAIMER}
      />

      <LiliButton
        id='planPickerTab'
        isLoading={flowContext.isLoading}
        title={t(TEXT.PLAN_PICKER.SUCCESS_BUTTON)}
        className={STYLES.INDEX.PLAN_PICKER.CONFIRMATION.BUTTON}
        onClick={onGreatClickHandler}
      />
    </div>
  );
};
